// extracted by mini-css-extract-plugin
module.exports = {"toastWidth":"Toast_toastWidth__4ro02","fadeToast":"Toast_fadeToast__bUK_j","fade":"Toast_fade__QFIZJ"};